// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","links":"Footer_links__q2x7d","link":"Footer_link__MsGIJ"};